"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _Typography = _interopRequireDefault(require("../Typography"));
var _ItemBase = _interopRequireDefault(require("./ItemBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps]);
const selectItemTextStyles = (_ref, themeOptions) => {
  let {
    itemFontHeight,
    itemFontSize,
    itemLineHeight,
    itemFontName,
    itemColor,
    itemTextColor
  } = _ref;
  return (0, _ThemeProvider.applyTextStyles)({
    fontWeight: itemFontHeight,
    fontSize: itemFontSize,
    fontName: itemFontName,
    color: itemColor || itemTextColor,
    themeOptions,
    lineHeight: itemLineHeight
  });
};
const selectItemCounterStyles = _ref2 => {
  let {
    itemBulletContainerWidth,
    itemBulletTextAlign,
    itemFontWeight,
    itemFontSize,
    itemFontName,
    itemLineHeight,
    themeOptions,
    itemColor,
    itemTextColor
  } = _ref2;
  return {
    color: itemColor || itemTextColor,
    width: itemBulletContainerWidth,
    textAlign: itemBulletTextAlign,
    ...(0, _ThemeProvider.applyTextStyles)({
      fontWeight: itemFontWeight,
      fontSize: itemFontSize,
      fontName: itemFontName,
      themeOptions
    }),
    lineHeight: itemLineHeight * itemFontSize
  };
};
const selectItemContentStyles = (_ref3, isLastChild) => {
  let {
    interItemMargin,
    listGutter,
    ...themeTokens
  } = _ref3;
  return {
    ...themeTokens,
    marginLeft: listGutter,
    marginBottom: !isLastChild ? interItemMargin : 0
  };
};
const Item = /*#__PURE__*/_react.default.forwardRef((_ref4, ref) => {
  let {
    children,
    index,
    isLastChild,
    title,
    tokens = {},
    variant,
    ...rest
  } = _ref4;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('OrderedList', tokens, variant);
  const headingTokens = title && {
    lineHeight: themeTokens.itemLineHeight,
    fontSize: themeTokens.itemFontSize,
    color: themeTokens.itemColor || themeTokens.itemTextColor,
    fontName: themeTokens.headerFontName,
    fontWeight: themeTokens.headerFontWeight
  };
  const {
    themeOptions
  } = (0, _ThemeProvider.useTheme)();
  const itemContent = (0, _utils.wrapStringsInText)(children, {
    style: selectItemTextStyles(themeTokens, themeOptions)
  });
  const itemCounter = (0, _utils.wrapStringsInText)(`${index}.`, {
    style: selectItemTextStyles(themeTokens, themeOptions)
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ItemBase.default, {
    ref: ref,
    style: {
      ...staticStyles.container,
      ...themeTokens
    },
    ...selectProps(rest),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: [staticStyles.itemCounter, selectItemCounterStyles(themeTokens)],
      children: itemCounter
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: [staticStyles.itemContent, selectItemContentStyles(themeTokens, isLastChild)],
      children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: {
            size: 'h4'
          },
          tokens: headingTokens,
          children: title
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        children: itemContent
      })]
    })]
  });
});
Item.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Item content
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Item index
   */
  index: _propTypes.default.number,
  /**
   * If true, the item is the last one on the list
   */
  isLastChild: _propTypes.default.bool,
  /**
   * Defines the title of the `OrderedList.Item`
   */
  title: _propTypes.default.string,
  /**
   * Item tokens
   */
  tokens: (0, _utils.getTokensPropType)('OrderedList'),
  /**
   * Item variant
   */
  variant: _utils.variantProp.propType
};
Item.displayName = 'OrderedListItem';
var _default = exports.default = Item;
const staticStyles = _StyleSheet.default.create({
  container: {
    flex: 1,
    flexDirection: 'row'
  },
  itemCounter: {
    alignItems: 'flex-end'
  },
  itemContent: {
    flexShrink: 1
  }
});